import { Box, FormLabel, Grid, TextField, Typography } from "@mui/material";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const PublicoObjetivo = () => {
  const { promptData, setPromptData } = useActividadesContext();

  const handlePublicoObjetivo = (event) => {
    const PublicoObjetivo = event.target.value;

    setPromptData((prevData) => ({
      ...prevData,
      publico_objetivo: PublicoObjetivo,
    }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            sx={{
              fontFamily: "montserrat",
              fontSize: "1.25rem",
              fontWeight: "bold",
              color: "#336B87",
            }}
          >
            Público objetivo *
          </Typography>
          <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
            Describe las características importantes de los profesores que
            participan en el taller. Por ejemplo años de experiencia, área
            temática u otras características
          </FormLabel>
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          value={promptData.publico_objetivo}
          placeholder="Ejemplo: Docentes de cuarto básico"
          onChange={handlePublicoObjetivo}
          InputProps={{
            sx: {
              borderRadius: 2,
              mt: 1,
              mb: 3,
              fontFamily: "montserrat",
              fontSize: "0.75rem",
              color: "#005559",
              "&::placeholder": {
                color: "#005559",
              },
              "&:before": {
                borderBottomColor: "#005559",
              },
              "&:after": {
                borderBottomColor: "#005559",
              },
            },
          }}
        />
      </Box>
    </Grid>
  );
};

export default PublicoObjetivo;
